<template>
	<div>
		<div v-if="!dialogVisible">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">考勤汇总</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row>

						<!-- 左侧组织架构 -->
						<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
							<Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
						</el-col>
						

						<!-- 右侧列表 -->
						<el-col :span="20">
							<el-row style="padding-left: 46px; padding-top: 20px;">
								<el-col :span="7">
									<span>时间</span>
									<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
										value-format="yyyy-MM" style="margin-left: 10px;">
									</el-date-picker>
								</el-col>

								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										查询</el-button>
								</el-col>

								<el-col :span="2">
									<download-excel class="export-excel-wrapper" :fields="download_excel"
										:name="condition.project_name" :fetch="ExportForm" style="top:100px;width:5%">
										<el-button
											style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
											导出</el-button>
									</download-excel>
								</el-col>

								<el-col :span="2">
									<el-button
										style="width: 110px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="heavyload" v-loading.fullscreen.lock="fullscreenLoading">
										更新考勤表</el-button>
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 10px;">
								<!-- <img src="../../../assets/1.jpg" style="width:100%"> -->
								<el-row style="margin-top: 5px;">
									<el-table :header-cell-style="{background:'#d3eae2',color:'#000000'}"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										height="470" tooltip-effect="dark" style="width: 100%;overflow: initial;"
										@selection-change="handleSelectionChange">
										<!--选框-->
										<!-- <el-table-column type="selection" width="55">
										</el-table-column> -->
										<el-table-column align="center" label="序号">
											<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
										</el-table-column>
										<el-table-column prop="staff_name" align="center" label="姓名"></el-table-column>
										<el-table-column prop="post_name" align="center" label="岗位" width="120">
										</el-table-column>
										<!-- <el-table-column prop="monthly_rest" align="center" label="月休"></el-table-column> -->
										<el-table-column align="center" v-for="(item, index) in tableTitle" :key="index"
											:label="item.leble" width="70">
											<template slot-scope="scope">
												<!-- {{prop(scope.row,index)}} -->
												<!-- <img :src="prop(scope.row,index)" > -->
												<img src="../../../assets/保洁绿化工程考勤符号/旷工.png"
													v-show="prop(scope.row,index) == '4'">
												<img src="../../../assets/保洁绿化工程考勤符号/上班拷贝260.png"
													v-show="prop(scope.row,index) == '1'">
												<img src="../../../assets/保洁绿化工程考勤符号/休息.png"
													v-show="prop(scope.row,index) == '0'">
												<img src="../../../assets/保洁绿化工程考勤符号/迟到.png"
													v-show="prop(scope.row,index) == '2'">
												<img src="../../../assets/保洁绿化工程考勤符号/早退.png"
													v-show="prop(scope.row,index) == '3'">
											</template>
										</el-table-column>
										<el-table-column align="center" label="出勤统计">
											<el-table-column prop="days_duty" align="center" label="应出">
											</el-table-column>
											<el-table-column prop="answer_days_duty" align="center" label="实出">
											</el-table-column>
											<el-table-column prop="monthly_rest" align="center" label="休息">
											</el-table-column>
											<!-- <el-table-column prop="post_name" align="center" label="病事假"></el-table-column> -->
											<!-- <el-table-column prop="post_name" align="center" label="加班"></el-table-column> -->
											<!-- <el-table-column prop="post_name" align="center" label="替班"></el-table-column> -->
											<el-table-column prop="lack_days_duty" align="center" label="旷工">
											</el-table-column>
										</el-table-column>
									</el-table>
								</el-row>
								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange"
										:page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</el-row>

							<el-row style="margin-top: 10px; text-align: center;">
								<el-table :header-cell-style="{background:'#d3eae2',color:'#000000'}"
									:row-class-name="tableRowClassName" ref="multipleTable" :data="tableDataDay"
									height="120" tooltip-effect="dark" style="width: 100%;">
									<el-table-column align="center" label="">
										<template slot-scope="scope_1">合计</template>
									</el-table-column>
									<el-table-column prop="date_1" align="center" label="1"></el-table-column>
									<el-table-column prop="date_2" align="center" label="2"></el-table-column>
									<el-table-column prop="date_3" align="center" label="3"></el-table-column>
									<el-table-column prop="date_4" align="center" label="4"></el-table-column>
									<el-table-column prop="date_5" align="center" label="5"></el-table-column>
									<el-table-column prop="date_6" align="center" label="6"></el-table-column>
									<el-table-column prop="date_7" align="center" label="7"></el-table-column>
									<el-table-column prop="date_8" align="center" label="8"></el-table-column>
									<el-table-column prop="date_9" align="center" label="9"></el-table-column>
									<el-table-column prop="date_10" align="center" label="10"></el-table-column>
									<el-table-column prop="date_11" align="center" label="11"></el-table-column>
									<el-table-column prop="date_12" align="center" label="12"></el-table-column>
									<el-table-column prop="date_13" align="center" label="13"></el-table-column>
									<el-table-column prop="date_14" align="center" label="14"></el-table-column>
									<el-table-column prop="date_15" align="center" label="15"></el-table-column>
									<el-table-column prop="date_16" align="center" label="16"></el-table-column>
									<el-table-column prop="date_17" align="center" label="17"></el-table-column>
									<el-table-column prop="date_18" align="center" label="18"></el-table-column>
									<el-table-column prop="date_19" align="center" label="19"></el-table-column>
									<el-table-column prop="date_20" align="center" label="20"></el-table-column>
									<el-table-column prop="date_21" align="center" label="21"></el-table-column>
									<el-table-column prop="date_22" align="center" label="22"></el-table-column>
									<el-table-column prop="date_23" align="center" label="23"></el-table-column>
									<el-table-column prop="date_24" align="center" label="24"></el-table-column>
									<el-table-column prop="date_25" align="center" label="25"></el-table-column>
									<el-table-column prop="date_26" align="center" label="26"></el-table-column>
									<el-table-column prop="date_27" align="center" label="27"></el-table-column>
									<el-table-column prop="date_28" align="center" label="28"></el-table-column>
									<el-table-column prop="date_29" align="center" label="29"></el-table-column>
									<el-table-column prop="date_30" align="center" label="30"></el-table-column>
									<el-table-column prop="date_31" align="center" label="31"></el-table-column>
									<el-table-column prop="days_duty" align="center" label="合计"></el-table-column>
								</el-table>
							</el-row>

							<el-row style="margin-left: 2%; margin-top: 5px;">
								<table width="1080px" style="font-size: 14px; font-weight: bold;">
									<tr height="30px">
										<td>
											<span>考勤符号：</span>
										</td>
										<td>
											<span>上班<img src="../../../assets/保洁绿化工程考勤符号/上班拷贝260.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">加班<img src="../../../assets/保洁绿化工程考勤符号/加班.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">支援<img src="../../../assets/保洁绿化工程考勤符号/支援.png"
													style="margin-left: 10px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">替班<img src="../../../assets/保安考勤符号/替班.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">旷工<img src="../../../assets/保洁绿化工程考勤符号/旷工.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">休息<img src="../../../assets/保洁绿化工程考勤符号/休息.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">迟到<img src="../../../assets/保洁绿化工程考勤符号/迟到.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">早退<img src="../../../assets/保洁绿化工程考勤符号/早退.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">病假<img src="../../../assets/保洁绿化工程考勤符号/病假.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">事假<img src="../../../assets/保洁绿化工程考勤符号/事假.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">婚假<img src="../../../assets/保洁绿化工程考勤符号/婚假.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">丧假<img src="../../../assets/保洁绿化工程考勤符号/丧假.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">入职<img src="../../../assets/保洁绿化工程考勤符号/入职.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 6px;">离职<img src="../../../assets/保洁绿化工程考勤符号/离职.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 8px;">夜班<img src="../../../assets/保安考勤符号/夜.png"
													style="margin-left: 5px;" /></span>
										</td>
										<td>
											<span style="margin-left: 8px;">正常班或白班<img src="../../../assets/保安考勤符号/白.png"
													style="margin-left: 5px;" /></span>
										</td>
									</tr>
								</table>
							</el-row>

						</el-col>

					</el-row>

				</div>
			</el-row>
		</div>

	</div>
</template>

<script>
	import Structure from "../../utils/structure/structure.vue";

	import axios from "axios";
	export default {
		components: {
			Structure: Structure,
		},
		data() {
			return {
				fullscreenLoading: false,
				//列表相关
				page_num: 1,
				page_size: 30,
				total: 0,
				tableData: [],
				tableDataDay:[],

				//页面相关
				dialogVisible: false,

				//职位下拉
				postList: [],

				//条件
				condition: {
					project_id: "",
					flag: "",
					post_id: "",
					staff_name: "",
					induction_time: "",
					years_date: this.$globals.getNowTimes()
				},

				//详情
				from: {
					id: "",
					zcimg: '',
				},

				//复选框ids
				ids: [],

				download_excel: {
					"姓名": "staff_name",
					"岗位": "post_name",
					"应出勤天数": "days_duty",
					"实出勤天数": "answer_days_duty",
					"休息": "monthly_rest",
					"旷工": "lack_days_duty",
					"1号": "date_1",
					"2号": "date_2",
					"3号": "date_3",
					"4号": "date_4",
					"5号": "date_5",
					"6号": "date_6",
					"7号": "date_7",
					"8号": "date_8",
					"9号": "date_9",
					"10号": "date_10",
					"11号": "date_11",
					"12号": "date_12",
					"13号": "date_13",
					"14号": "date_14",
					"15号": "date_15",
					"16号": "date_16",
					"17号": "date_17",
					"18号": "date_18",
					"19号": "date_19",
					"20号": "date_20",
					"21号": "date_21",
					"22号": "date_22",
					"23号": "date_23",
					"24号": "date_24",
					"25号": "date_25",
					"26号": "date_26",
					"27号": "date_27",
					"28号": "date_28",
					"29号": "date_29",
					"30号": "date_30",
					"31号": "date_31",
				}
			};
		},
		methods: {
			Return() {
				this.dialogVisible = false;
				this.Find();
			},
			//查询
			Find() {
				this.initializeTableTitle();
				const url = this.$globals.http + "CheckAttendance/selectAll";
				axios.post(url, {
					page_num: this.page_num,
					page_size: this.page_size,
					staff_name: this.condition.staff_name,
					project_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
						this.FindDay();
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			FindDay() {
				const url = this.$globals.http + "CheckAttendanceTotal/selectByPrimaryOne";
				axios.post(url, {
					project_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
			
					if (code === '200') {
						this.tableDataDay = data;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			// heavyload重载 刷新
			heavyload() {
				this.fullscreenLoading = true;
				this.initializeTableTitle();
				const url = this.$globals.http + "CheckAttendance/Generate";
				axios.post(url, {
					applicant_id: this.$globals.user.staff_id,
					staff_name: this.condition.staff_name,
					project_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
						this.fullscreenLoading = false;
					} else {
						this.fullscreenLoading = false;
						this.$message.warning(data);
					}
				}).catch((error) => {
					console.log(error)
					this.fullscreenLoading = false;
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//导表
			async ExportForm() {
				var url = 'CheckAttendance/Daobiao';
				var record = {
					project_id: this.condition.project_id,
					years_date: this.condition.years_date,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if (data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					}
				}
			},
			//获取表头
			async initializeTableTitle() {
				var year_date = this.condition.years_date + '-01';
				var tableTitle = await this.$globals.AxiosPost("scheduling/findTableTitle", {
					years_date: year_date,
				});
				this.tableTitle = tableTitle.data;

			},
			//字体数据
			prop(row, index) {
				return row[this.tableTitle[index].data];
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val
				this.Find();
			},

		},
		async created() {
			// this.Find();
		}
	}
</script>

<style scoped="scoped">
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// KqHz.vue?5606373f